import { createContext } from "react";
import type { Authority, Principal } from "./authorities";

export interface AuthState {
  principal: Principal | null;
  isAuthenticated: boolean;
  signIn: (username: string, password: string, rememberMe?: boolean) => Promise<Principal>;
  signOut: () => void;
  /** Sidebar / button affordance check -- honours the SUPER_ADMIN bypass. */
  can: (authority: Authority) => boolean;
  canAny: (authorities: readonly Authority[]) => boolean;
}

export const AuthContext = createContext<AuthState | null>(null);
